import { render, staticRenderFns } from "./NotificationTemplateCode.vue?vue&type=template&id=2ddc3df2&"
import script from "./NotificationTemplateCode.vue?vue&type=script&lang=ts&"
export * from "./NotificationTemplateCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports